import { type CreateSecondaryCategoryInputData } from '../types/CreateSecondaryCategoryInputData'
import { type CreateSecondaryCategoryPayload } from '../types/CreateSecondaryCategoryPayload'

/**
 * Maps input data to the create secondary category API payload format.
 * This transformation is data access logic that converts camelCase to snake_case
 * as required by the API.
 *
 * @param inputData - Domain-level input data
 * @returns Payload formatted for the create API endpoint
 */
export const mapCreateSecondaryCategoryInputDataToPayload = (
  inputData: CreateSecondaryCategoryInputData
): CreateSecondaryCategoryPayload => {
  return {
    name: inputData.name,
    external_id: inputData.externalId,
    punchout_email: inputData.punchoutEmail,
  }
}
